import { event_load } from "../data"


export async function search_event(props) {
    const Set_eventList = window.EventManager.Set_eventList

    await Set_eventList([])

    const searchWord = props['searchWord']
    const Set_eventLoading = props['Set_eventLoading']

    await Set_eventLoading(true)

    const result = await event_load(searchWord)

    if(result) {
        await Set_eventLoading(false)
    }
}